import { Fragment, useState } from 'react'
import { Dialog, Transition } from '@headlessui/react'
// import { CheckIcon } from '@heroicons/react/outline'
import BounceLoader from "react-spinners/BounceLoader";
import { css } from "@emotion/core";
import PainPopper from '../../../messagingPage/components/Popover/PainPopper';
import ProductEx from '../../../messagingPage/components/Popover/ProductEx';
import { AutoGenVPOnboard } from '../../../messagingPage/functions/AddValueProp';

const override = css`
  display: inline-block;
  margin: 20px;
`;

function OnboardVProp({
    setShowOBvprop,
    showOBvprop,
    profile,
    auth,
    FBvalueProp,
    setShowOBdone
}) {
    
  
    const [ value, setValue ] = useState('')
    const [ pain, setPain ] = useState('')
    const [ compName, setCompName ] = useState('')
    const [ vCount, setVCount ] = useState(0)
    const [ pCount, setPCount ] = useState(0)
    const [ showSpinner, setShowSpinner ] = useState(false)
    const [ disabled, setDisabled ] = useState(false) 
    const [ error, setError ] = useState('')



    const valueFunc = (e) =>{
        setVCount(e.target.value.length)
        setValue(e.target.value)
            if(e.target.value.length > 200){
                setDisabled(true)
            } else {
                setDisabled(false)
            }
    }
    
    const painFunc = (e) =>{
        setPCount(e.target.value.length)
        setPain(e.target.value)
            if(e.target.value.length > 200){
                setDisabled(true)
            } else {
                setDisabled(false)
            }
    }

    const startFormat = () =>{
        setError("")
        setShowSpinner(true)
        AutoGenVPOnboard(compName, value, pain, auth, setShowOBvprop, profile, setShowSpinner, FBvalueProp, setShowOBdone, setError)
    }
 
    return (
    <Transition.Root show={showOBvprop} as={Fragment}>
        <Dialog
          as="div"
          static
          className="fixed z-10 inset-0 overflow-y-auto w-full"
          // initialFocus={cancelButtonRef}
          open={showOBvprop}
          onClose={setShowOBvprop}
        >
          <div className="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0"
              enterTo="opacity-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100"
              leaveTo="opacity-0"
            >
              <Dialog.Overlay className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
            </Transition.Child>
  
            {/* This element is to trick the browser into centering the modal contents. */}
            <span className="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true">
              &#8203;
            </span>
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              enterTo="opacity-100 translate-y-0 sm:scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 translate-y-0 sm:scale-100"
              leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            >
              <div className="inline-block align-bottom bg-white rounded-lg px-4 pt-5 pb-4 text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full sm:p-6">
                <div>
                  {/* <div className="mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-green-100">
                    <CheckIcon className="h-6 w-6 text-green-600" aria-hidden="true" />
                  </div> */}
                  <div className="mt-1 text-left">
                    {/* <Dialog.Title as="h3" className="text-lg leading-6 font-medium text-gray-900">
                      Value Proposition Generator
                    </Dialog.Title> */}
                    {/* <div className="mt-2 mb-4">
                      <p className="text-sm text-gray-600">
                      Fill in the blanks as best you can and our AI will create a value proposition for you to use.
                      </p>
                    </div> */}
                    <div>
                    <p className="my-1 font-medium">
                      Company Name
                    </p>
                    <input 
                    placeholder="Bound"
                    className="border-2 border-gray-200 p-1 rounded-lg w-full focus:ring focus:outline-none"
                    onChange={(e) => setCompName(e.target.value)}
                    />
                    </div>
                    <div className="my-4">
                    <div className="flex">
                      <p className="my-1 font-medium">
                      Tell us what your product does
                      </p>
                      <div className="ml-2 my-1">
                          <ProductEx />
                      </div>
                    </div>
                    <textarea 
                    placeholder="Bound creates personal and creative messages that book you more meetings."
                    className="border-2 border-gray-200 p-1 rounded-lg w-full focus:ring focus:outline-none"
                    onChange={(e) => valueFunc(e)}
                    />
                    <div className="float-right text-xs text-gray-500">
                      {vCount}/200
                    </div>
                    </div>
                    <div>
                      <div className="flex">
                        <p className="my-1 font-medium">
                        What pain does your customer feel because they dont use you?
                        </p>
                        <div className="ml-2 my-1">
                        {/* <PainEx /> */}
                        <PainPopper />
                        </div>
                      </div>
                    <textarea 
                    placeholder="Writing concise and engaging outbound messages quickly is hard."
                    className="border-2 border-gray-200 p-1 rounded-lg w-full focus:ring focus:outline-none"
                    onChange={(e) => painFunc(e)}
                    />
                    </div>
                    <div className="float-right text-xs text-gray-500">
                      {pCount}/200
                    </div>
                  </div>
                </div>
                <div className="mt-8">
                  <button
                    type="button"
                    className="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-indigo-600 text-base font-medium text-white hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:col-start-2 sm:text-sm"
                    onClick={() => startFormat()}
                    disabled= {disabled || (pCount === 0 || vCount === 0 || compName.length === 0)}
                  >
                    Feed To Bound
                  </button>
                  {/* <button
                    type="button"
                    className="mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:mt-0 sm:col-start-1 sm:text-sm"
                    onClick={() => setShowVpropMod(false)}
                  //   ref={cancelButtonRef}
                  >
                    Cancel
                  </button> */}
                </div>
                {error === "" 
                ?
                (showSpinner ?
                <div className="text-center mt-4 grid w-full justify-items-center">
                  <BounceLoader size={75} css={override} color='#4F46E5'/>
                  <p className="mt-1 text-base font-semibold">Bound is creating and<br /> storing your value prop</p>
                </div>
                :
                null )
                :
                <div className="mt-6 p-2 border-2 border-red-200 rounded-lg font-medium text-left">
                  {error}
                </div>
                }
              </div>
            </Transition.Child>
          </div>
        </Dialog>
      </Transition.Root>
    )
}

export default OnboardVProp
